import React, { useState } from "react"
import AffiliatesMap from "./AffiliatesMap"
import { useStaticQuery, graphql } from "gatsby"
import "./index.scss"
import AffiliatesGridSlider from "./AffiliatesGridSlider"

export default function AffiliatesMapSection() {
  //  = = = = = = = = = =
  // Use States
  const [map, setMap] = useState(true)

  //  = = = = = = = = = =
  // Event Handlers
  const handleSwitch = () => {
    setMap(!map)
  }

  //  = = = = = = = = = =
  // Graphql
  const affiliatesData = useStaticQuery(graphql`
    query affiliatesQuery {
      affiliates: allDatoCmsAffiliate(sort: { fields: name, order: ASC })  {
        nodes {
          intro
          websiteLink
          name
          locationText
          image {
            gatsbyImageData(placeholder: BLURRED)
          }
          location {
            latitude
            longitude
          }
        }
      }
    }
  `)

  const affiliates = affiliatesData.affiliates
  return (
    <div data-datocms-noindex className="affiliates-map-section">
      <div className="container">
        <div className="row">
          <div className="affiliates-map-section__toggle">
            <h5
              className="oblique"
              style={{ color: map ? "#18988B" : "#AAAFC9" }}
            >
              Map View
            </h5>
            <input
              type="checkbox"
              id="switch"
              onChange={() => handleSwitch()}
            />
            <label for="switch">Toggle</label>
            <h5
              className="oblique"
              style={{ color: map ? "#AAAFC9" : "#18988B" }}
            >
              List View
            </h5>
          </div>
        </div>
        {map ? (
          <AffiliatesMap affiliates={affiliates} />
        ) : (
          <AffiliatesGridSlider affiliates={affiliates} />
        )}
        <div className="mobileGrid">
          <AffiliatesGridSlider affiliates={affiliates} />
        </div>
      </div>
    </div>
  )
}
